import React from "react";
import PropTypes from "prop-types";
import { completeOAuth, extractSyncError } from "../../../utils/api/SyncApi";

export default class CleverConfigurationLink extends React.Component {
  componentDidMount() {
    const self = this;
    const query = this.props.location.query;

    const redirectBack = () => self.context.router.push("/config/device/authentication/clever");
    const redirectWithError = (message) => {
      self.context.router.push({
        pathname: "/config/device/authentication/clever",
        state: { linkError: message },
      });
    };

    if (query.error) {
      redirectWithError(query.error_description || "Credentials linking was denied or cancelled.");
      return;
    }

    if (!query.code) {
      redirectWithError("Credentials linking was denied or cancelled.");
      return;
    }

    const storedState = localStorage.getItem("oauth_state_CLEVER");
    localStorage.removeItem("oauth_state_CLEVER");
    if (!storedState) {
      redirectWithError("Credential linking was not started from School Manager. Please log in with Clever from this page.");
      return;
    }
    if (!query.state || query.state !== storedState) {
      redirectWithError("Credential linking could not be verified. Please try again.");
      return;
    }
    completeOAuth(storedState, query.code)
      .then(redirectBack)
      .catch((e) => redirectWithError(extractSyncError(e, "Failed to link Clever credentials. Please try again.")));
  }

  render() {
    return <div />;
  }
}

CleverConfigurationLink.contextTypes = {
  router: PropTypes.object.isRequired,
};
